export default String.raw`
<div class="cart-row">
    {% assign loopStart = forloop.index0 -%}
    {% assign loopEnd = cart.Products | Size | Minus: 1 -%}

    {% assign productsSize = cart.Products | Size -%}

    {% assign price = product.Price | Minus: product.Price -%}
    {% assign productValue = product.Value | Minus: product.Value -%}
    {% assign priceBefore = product.ValueBeforeDiscount | Minus: product.ValueBeforeDiscount -%}

    {% if config.ENTERPRISE -%}
        {% assign totalPrice = product.TotalPrice | Minus: product.TotalPrice -%}
        {% assign totalValue = product.TotalValue | Minus: product.TotalValue -%}
    {% endif -%}

    {% for setElIndex in (loopStart..loopEnd) -%}
        {% assign setEl = cart.Products[setElIndex] -%}   
        {% if setEl.IsSetElement == false or (setEl.IsSetParent and setElIndex > loopStart) -%}
            {% break -%}
        {% endif -%}
        {% if config.ENTERPRISE -%}
            {% assign price = price | Plus: setEl.SubtotalPrice -%}
            {% assign productValue = productValue | Plus: setEl.SubtotalValue -%}
            {% assign priceBefore = priceBefore | Plus: setEl.SubtotalValueBeforeDiscount -%}
            {% assign totalPrice = totalPrice | Plus: setEl.TotalPrice -%}
            {% assign totalValue = totalValue | Plus: setEl.TotalValue -%}
        {% else -%}
            {% assign price = price | Plus: setEl.Price -%}
            {% assign productValue = productValue | Plus: setEl.Value -%}
            {% assign priceBefore = priceBefore | Plus: setEl.ValueBeforeDiscount -%}
        {% endif -%}
    {% endfor -%}

    <div class="cart-row__number"></div>

    <div class="cart-row__product cart-row__product-wrapper">
		<div class="cart-row__product-image">
            {% if product.AskForPrice -%}
                <img src="css/img/img-placeholder.jpg" alt="{{translations.DefaultImage}}" loading="eager" fetchpriority="high">
            {% elseif product.ImageId != -1 -%}
                {{ product | Img: 'small' }}
            {% else -%} 
                <img src="css/img/img-placeholder.jpg" alt="{{translations.DefaultImage}}" loading="eager" fetchpriority="high">
            {% endif -%}
		</div>
		<div>
            {% if product.AskForPrice -%}
                <a href="{{ page.BaseHref }}{{config.DefinedPages.CustomerProfile.Url}}?offerId={{ product.AskForPriceId }}&deeper-lvl&tab=offer-details&from-cart=true" class="cart-row__product-name" rel="noopener noreferrer nofollow">{{ product.SetName }}</a>
            {% elseif product.Url -%}
                <a href="{{ page.BaseHref }}{{ product.Url }}" class="cart-row__product-name">{{ product.SetName }}</a>
			{% else -%}
				<div class="cart-row__product-name">{{ product.SetName }}</div>
			{% endif -%}
			<ul class="cart-row__product-info primary-color">
				<li>{{translations.Set}}</li>
			</ul>
		</div>
	</div>

    <div class="cart-row__price"></div>

    {% if config.ENTERPRISE -%}
        <div class="cart-row__total-price"></div>
    {% endif -%}

    <div class="cart-row__quantity">
        <div class="cart-row__quantity-amount">
			<div>
				1
			</div>
			<div class="cart-amount-stepper-unit">
				{% if product.AskForPrice -%}
                    {{translations.OfferShort}}
                {% else -%}
                    {{translations.Set}}
                {% endif -%}
			</div>
		</div>
    </div>

    {% if isDiscount -%}
        <div class="cart-row__additional cart-hide-on-desktop">
            <div class="cart-additional-info">
                <div class="cart-additional-info__title">{{translations.Discount}}</div>
                <div class="cart-additional-info__content">
                    {% assign discount = priceBefore | Minus: productValue | DividedBy: priceBefore | Times: 100 | Round: 0 -%}
                    {% if priceBefore != 0 and discount != 0 -%}
                        {{discount}} %
                    {% endif -%}
                </div>
            </div>
        </div>
    {% endif -%}

    <div class="cart-row__value">
        {% if config.ENTERPRISE or cart.SubtotalPrices -%}
			{% if productValue > 0 -%}
				<div class="cart-hide-on-desktop">
					<span class="cart-bold-price">{{ productValue | ToPrice }}</span>
					<span class="cart-hide-on-desktop cart-bold-price">{{ cart.CurrencyExt }}</span>
					<span class="cart-hide-on-desktop">{{translations.Netto | Downcase}}</span>
				</div>
			{% endif -%}
		{% endif -%}

        {% if config.ENTERPRISE -%}
			{% if totalValue > 0 -%}
				<div class="cart-small-price">
					<span>{{ totalValue | ToPrice }}</span>
					<span class="cart-hide-on-desktop">{{ cart.CurrencyExt }}</span>
					<span class="cart-hide-on-desktop">{{translations.Brutto | Downcase}}</span>
				</div> 
			{% endif -%}
		{% else -%}
			{% if productValue > 0 -%}
				<div>
					<span class="cart-bold-price">{{ productValue | ToPrice}}</span>
					<span class="cart-hide-on-desktop cart-bold-price">{{ cart.CurrencyExt }}</span>
					<span class="cart-hide-on-desktop">{{translations.Brutto | Downcase}}</span>
				</div> 
			{% endif -%}
		{% endif -%}
	</div>

    <div class="cart-row__currency">
        {{ cart.CurrencyExt }}
    </div>

    <div class="cart-row__options">
        <button class="cart-row__options-btn chevron expand-data-js {% if product.AskForPrice and cart.OrderStep == 'Start' -%} expanded-js {% endif -%}">
            <svg>
				<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-down-{{settings.iconStyle}}"></use>
			</svg>
        </button>
        {% if orderStep != 'Third' -%}
            <div class="cart-row__options-deleter form-js no-message-js">
                <input type="hidden" name="__action" value="Cart/PositionDelete">
                <input type="hidden" name="no" value="{{ product.No }}">
                <button class="cart-row__options-btn remove-product-from-cart-js parent-container-reload-js {% if product.AskForPrice -%} remove-offer-js {% endif -%} {% if productsSize == 1 -%} last-product-js {% endif -%}" title="{{ translations.Delete }}" data-id="{{product.Id}}" data-name="{{ product.SetName }}" data-price="{{ price }}" data-quantity="1">
                    <svg>
                        <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#trash-alt-{{settings.iconStyle}}"></use>
                    </svg>
                </button>
            </div>
        {% endif -%}
    </div>
</div>

<div class="cart-row__expandable expandable-js">
    <div class="cart-row__additional-info">
        {% if config.ENTERPRISE or cart.SubtotalPrices -%}
            {% if productValue > 0 -%}
                <div class="cart-additional-info">
                    <div class="cart-additional-info__title">{{translations.Value}} {{translations.Netto | Downcase}}</div>
                    <div class="cart-additional-info__content">{{ productValue | ToPrice }} {{ cart.CurrencyExt }}</div>
                </div>
            {% endif -%}
        {% endif -%}

        {% if isDiscount -%}
            <div class="cart-additional-info">
                <div class="cart-additional-info__title">{{translations.Discount}}</div>
                <div class="cart-additional-info__content">
                    {% assign discount = priceBefore | Minus: productValue | DividedBy: priceBefore | Times: 100 | Round: 0 -%}
                    {% if priceBefore != 0 and discount != 0 -%}
                        {{discount}} %
                    {% endif -%}
                </div>
            </div>
        {% endif -%}
    </div>
</div>
`